SupportServiceActionsBaseView = require('./service_action_base')
SupportServiceActionButtonTemplate = require('../../../../service_action_button.html.mustache')

class SupportTrackOrderServiceActionView extends SupportServiceActionsBaseView
  id: 'track_order'

  events :
    "click #track_order": "actionHandler"

  initialize: ->
    @I18nScope = 'modules.support'
    @template = SupportServiceActionButtonTemplate
    @order = Groupon.Support.currentOrder
    @voucher = Groupon.Support.currentOrder.groupons[0]

  render: ->
    @$el.append toHtml(@template, @toHash(), @I18nScope)

  toHash: ->
    hash =
      service_action_id : "track_order",
      service_action : I18n.t("js.modules.support.track_order")
    @extendHash(hash)

  actionHandler: ( event )->
    url = Groupon.Support.currentOrder.trackingUrl
    window.open(url ,'_newtab')

module.exports = SupportTrackOrderServiceActionView
